import { render, staticRenderFns } from "./compileRole.vue?vue&type=template&id=81a7eb64&scoped=true&"
import script from "./compileRole.vue?vue&type=script&lang=js&"
export * from "./compileRole.vue?vue&type=script&lang=js&"
import style0 from "./compileRole.vue?vue&type=style&index=0&id=81a7eb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a7eb64",
  null
  
)

export default component.exports